import { useMemo } from 'react';

export const useIsInIframe = (): boolean => useMemo(() => {
  try {
    // Method 1: Standard check
    if (window.self !== window.top) {
      return true;
    }

    // Method 2: Check parent reference
    if (window.parent && window.parent !== window.self) {
      return true;
    }

    // Method 3: Check frameElement (works for same-origin iframes)
    if (window.frameElement !== null) {
      return true;
    }

    // Method 4: Check window.length (number of frames in the window)
    if (window.top && window.top.length > 0 && window.self !== window.top) {
      return true;
    }

    // If none of the checks indicate an iframe, return false
    return false;
  } catch (e) {
    // Cross-origin access blocked → definitely in an iframe
    return true;
  }
}, []);
